import Swiper, { Navigation, Scrollbar, Mousewheel, FreeMode } from 'swiper';

const classes = {
  swipeableTabs: 'is-swipeable-tabs',
  swipeableCarousel: 'is-swipeable-carousel',
  wrapperCenter: 'swiper-wrapper--center',
  btnDisabled: 'swiper-button-hidden',
};

const collectionsExplorer = (data) => ({
  selectedIdx: 0,

  /**
   * Applies conditional classes if swiper is scrollable or not
   * @param {Swiper} swiper - Swiper instance
   * @param {Object} alpine - Alpine JS instance
   * @param {String} rootClass - Class to toggle on the root element
   */
  swiperCenterOnNoScroll: (swiper, alpine, rootClass) => {
    const isSwipeable = swiper.virtualSize > swiper.size;
    if (isSwipeable) {
      if (rootClass) alpine.$root?.classList.add(rootClass);
      swiper.wrapperEl?.classList.remove(classes.wrapperCenter);
    } else {
      if (rootClass) alpine.$root?.classList.remove(rootClass);
      swiper.wrapperEl?.classList.add(classes.wrapperCenter);
    }
  },

  get swiperTabsConfig() {
    return {
      slidesPerView: 'auto',
      on: {
        ppClick: (_, event) => {
          event.target.dispatchEvent(new CustomEvent('swiper-tap'));
        },
        init: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableTabs),
        resize: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableTabs),
      },
      modules: [Mousewheel, FreeMode],
      mousewheel: true,
      freeMode: {
        momentum: false,
      },
    };
  },

  get sharedSwiperConfig() {
    return {
      slidesPerView: 'auto',
      modules: [Navigation, Scrollbar, Mousewheel],
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      grabCursor: true,
      watchOverflow: true,
      centeredSlides: false,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        disabledClass: classes.btnDisabled,
      },
      on: {
        init: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableCarousel),
        resize: (swiper) =>
          this.swiperCenterOnNoScroll(swiper, this, classes.swipeableCarousel),
      },
      ...this.sharedSwiperConfigOverrides,
    };
  },

  cacheNodes() {
    this.swiperTabsEl = this.$el.querySelector('.swiper[swiper-tab-bank]');
    this.swiperContentEls = this.$el.querySelectorAll(
      '.swiper:not([swiper-tab-bank])'
    );
  },

  setData() {
    this.isSwatches = this.$el.hasAttribute('swatch-collections-explorer');

    if (data) {
      this.carouselTypeMobile = data.carouselTypeMobile;
      this.carouselTypeDesktop = data.carouselTypeDesktop;
      this.sharedSwiperConfigOverrides = data.sharedSwiperConfigOverrides;
    }
  },

  buildSwipers() {
    // Tabs setup
    if (this.swiperTabsEl) {
      this.swiperTabsInstance = new Swiper(
        this.swiperTabsEl,
        this.swiperTabsConfig
      );
    }

    // Content setup
    if (this.swiperContentEls) {
      this.swiperContentInstances = Array.from(this.swiperContentEls).map(
        (swiperEl) => {
          const slideCount = swiperEl.querySelectorAll('[swiper-slide]').length;
          const loopMobile = this.carouselTypeMobile
            ? this.carouselTypeMobile === 'loop'
            : true;
          const loopDesktop = this.carouselTypeDesktop
            ? this.carouselTypeDesktop === 'loop'
            : true;
          let config;

          if (this.isSwatches) {
            config = {
              ...this.sharedSwiperConfig,
              loop: loopMobile && slideCount > 3,
              centeredSlides: loopMobile && slideCount > 3,
              breakpoints: {
                768: {
                  loop: loopDesktop && slideCount > 4,
                  centeredSlides: loopDesktop && slideCount > 4,
                },
                1024: {
                  loop: loopDesktop && slideCount > 4,
                  centeredSlides: loopDesktop && slideCount > 4,
                },
              },
            };
          } else {
            config = {
              ...this.sharedSwiperConfig,
              loop: loopMobile,
              centeredSlides: loopMobile,
              breakpoints: {
                1024: {
                  loop: loopDesktop,
                  centeredSlides: loopDesktop,
                },
              },
            };
          }

          return new Swiper(swiperEl, config);
        }
      );
    }
  },

  init() {
    this.cacheNodes();
    this.setData();
    this.buildSwipers();
  },
});

export default collectionsExplorer;
